module.exports = __webpack_public_path__ + "static/media/cart-done-icon-active.34a9f77d.svg";